import { createContext } from '@lit/context'

/**
 * Signals to a [NavItem](/components/nav-item/) that it is rendered inside a
 * [NavGroup](/components/nav-group/), which exposes `role="list"`. The nav-item
 * consumes this to decide whether to emit `role="listitem"`: a `listitem`
 * without a `list` ancestor is an accessibility violation
 * (`aria-required-parent`), so standalone nav-items (e.g. directly in
 * `nord-navigation` or used as a `nord-dropdown` toggle) omit the role instead.
 */
export const navListContext = createContext<boolean>(Symbol('nord-nav-list'))
